module.exports = __webpack_public_path__ + "img/205.3e3cb05b.png";